export const ButtonEvent = {
	forceSave: "force_save"
} as const;
